import { ChangeEvent } from 'react'
import styles from '../../AdminTools.module.css'

interface HeaderAlignedStandardValueInputProps {
  label: string
  name: string
  inputValue: string
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void
}

export const HeaderAlignedStandardValueInput = ({
  label,
  name,
  inputValue,
  handleChange,
}: HeaderAlignedStandardValueInputProps) => {
  return (
    <div className={styles.headerAlignedRow}>
      <div className={styles.headerAlignedLabel}>{label}</div>
      <input
        type="text"
        name={name}
        value={inputValue}
        onChange={handleChange}
        className={styles.standardValueInput}
        style={{ width: '100px', textAlign: 'right' }}
      />
    </div>
  )
}
